import React, { useEffect, useState } from "react";
import find from "lodash/find";
import ReactDatePicker from "react-datepicker";
import { User, Calendar, X } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";
import moment from "moment";
import api from "../../../utils/api";
import close_modal from "./../../../assets/ic_close_wh.svg";
import Spinner from "../../../common/Spinner/Spinner";

export default function ViewAllSMSLogModel(props)
{
    const [auditLog,setAuditLog] = useState();
    const [isLoading, setLoading] = useState(false);
    
    useEffect(() => {
    if(props.isOpen)
    {
        if(props.sEmailAddress)
        {
            setLoading(true);
            api.getAllFollowupSMSByUserid({email: props.sEmailAddress})
            .then((d) => {
                setAuditLog(d.data);
                let data=d.data;
                setLoading(false);
            });
        }            
    }
    
    }, [props.isOpen]);

    const renderAuditTrail = () => {

        return Object.keys(auditLog).map((key, i) => (
            <> 
                <div className="notes-trail-service-text">{`${auditLog[key].sServiceName} (${key}) `}</div>
                {
                    auditLog[key].sms.length>0?
                    (
                    Object.keys(auditLog[key].sms).map((key1, i) => (
                    <div className={`${i%2==0?'notes-trail-box-even':'notes-trail-box-odd'}`} key={i}>              
                        <div className="flex justify-content-between">
                        <small className="notes-trail-text">{auditLog[key].sms[key1].external_sp}</small>
                        <small className="notes-trail-text">{moment(auditLog[key].sms[key1].date_created).format('lll')}</small>
                        </div>
                        <div className="conv-mt15">
                        <div><small className="notes-trail-text">SMS</small></div>
                        <div className="notes-trail-content-text conv-mt5" style={{whiteSpace: "pre-line"}}>
                            {auditLog[key].sms[key1].sms_content}
                        </div>   
                        </div>
                    </div>
                    ))
                    ):
                    (<div className="notes-trail-box-even">No SMS sent</div>)
                }
          </>
        ))
    }

    return (
        <Modal
            isOpen={props.isOpen}
            onRequestClose={props.toggleModal}
            ariaHideApp={false}
        >
            <ModalContent className="lpm-notes-trail-modal">
                <div className="modal-header">
                    <span className="modal-title">All SMS Trail</span>
                    <img
                        alt="close"
                        id="Close"
                        src={close_modal}
                        className="close modal-close"
                        onClick={props.toggleModal}
                    />
                </div>
                <div className={`modal-body notes-trail-content conv-pl25 conv-pr25 custom-scrollbar ${isLoading && "set-opacity"}`}>
                    {isLoading && <Spinner className="top"/>}
                    <div className="conv-mt10">                
                        {auditLog?renderAuditTrail():<div className="notes-trail-box-even">No SMS Sent</div>}
                    </div>
                </div>            
            </ModalContent>
        </Modal>
    );
}